import apiClient from './apiClient';
import { DELETE_EXCHANGE_RATE_URL } from './apiUrl';

const deleteExchangeRateApi = id => {
  return apiClient.delete(`${DELETE_EXCHANGE_RATE_URL}${id}`);
};

export { deleteExchangeRateApi };
